import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import Link from '@mui/material/Link';
import icNoComunication from '../../assets/images/ic_nocomunication.svg';

const useStyles = makeStyles((_) => ({
  root: {
    flexGrow: 1,
  },
}));

/**
 * Useful when you require show info o message if the current request fail.
 * @param onClickHandler dispatch an action
 * */
export default function RetryData({ onClickHandler = undefined }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '65vh' }}
      >
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <img
            src={icNoComunication}
            alt="Sin comunicación"
          />
          <p>No se pudo obtener la informacion solicitada.</p>
          {onClickHandler && (
            <Link component="button" onClick={onClickHandler}>
              <p>Retry</p>
            </Link>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

RetryData.propTypes = {
  onClickHandler: PropTypes.func,
};
